import React, { useState, useEffect } from "react";
import { BsSunriseFill, BsSunsetFill } from "react-icons/bs";
import performRequest from "../../api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { Toast } from "../../CustomComponent/toast";
import { socket } from "../../api/socket.io";
import { useLocation, useNavigate } from "react-router";

function formatToIndianNumberingSystem(number) {
  const formatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
  });
  return formatter.format(number);
}

const FooterCopyright = () => {
  const [data, setData] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const themeKey = "tablerTheme";
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const excludedPage = "/hydroponic-material-planning/table"; // Page without theme
    const excludedPage2 = "/employee-payslip";

    if (
      location.pathname === excludedPage ||
      location.pathname === excludedPage2
    ) {
      document.body.removeAttribute("data-bs-theme");
      return;
    }

    let theme =
      new URLSearchParams(location.search).get("theme") ||
      localStorage.getItem(themeKey) ||
      "light";

    setIsDarkMode(theme === "dark");
    localStorage.setItem(themeKey, theme);

    document.body.setAttribute("data-bs-theme", theme);

    // Update URL only if theme is missing from the query
    if (!new URLSearchParams(location.search).get("theme")) {
      const params = new URLSearchParams(location.search);
      params.set("theme", theme);
      navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  const toggleTheme = () => {
    const newTheme = isDarkMode ? "light" : "dark";
    setIsDarkMode(!isDarkMode);
    localStorage.setItem(themeKey, newTheme);

    if (
      location.pathname !== "/hydroponic-material-planning/table" ||
      location.pathname !== "/employee-payslip"
    ) {
      document.body.setAttribute("data-bs-theme", newTheme);
    }

    const params = new URLSearchParams(location.search);
    params.set("theme", newTheme);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  useEffect(() => {
    performRequest("GET", "/cultivation/getTotalCultivation/")
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.totalArea);
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    socket.on("getCultivation", (getCultivation) => {
      setData(getCultivation);
    });

    return () => {
      socket.off("getCultivation"); // Clean up on unmount
    };
  }, [socket]);

  const [currentDateTime, setCurrentDateTime] = useState({
    date: "",
    time: "",
  });

  const getDateTime = (date) => {
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour12: true,
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
    });
    const formattedDate = `${
      date.getMonth() + 1
    }/${date.getDate()}/${date.getFullYear()}`;
    setCurrentDateTime({ date: formattedDate, time: formattedTime });
  };

  useEffect(() => {
    const initialDate = new Date();
    getDateTime(initialDate);
    const intervalId = setInterval(() => {
      const currentDate = new Date();
      getDateTime(currentDate);
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <footer className="footer footer-transparent d-print-none">
      <hr />
      <div className="container-xl">
        <div className="d-flex row text-center">
          <div className="text-center mb-3">
            {!(
              location.pathname === "/hydroponic-material-planning/table" ||
              location.pathname === "/employee-payslip"
            ) && (
              <button className="btn btn-6 btn-outline " onClick={toggleTheme}>
                {isDarkMode ? (
                  <BsSunriseFill className="fs-2 me-2" />
                ) : (
                  <BsSunsetFill className="fs-2 me-2" />
                )}
                Switch to {isDarkMode ? "Light" : "Dark"} Mode
              </button>
            )}
          </div>
          <p className="m-0">Total hydroponic cultivation</p>
          <b className="mt-0 mb-1" style={{ fontSize: "30px" }}>
            {formatToIndianNumberingSystem(data)} sqft
          </b>
          <p className="mb-1">
            {currentDateTime.date} {currentDateTime.time}
          </p>
          <p className="p-0">
            <a
              href="/request-refund"
              className="text-decoration-none"
              style={{ color: "#6c7a91" }}
            >
              Request a Refund
            </a>
          </p>
          <p>
            Copyright &copy; 2019 - 2026{" "}
            <a
              className="text-decoration-none"
              style={{ color: "#6c7a91" }}
              href="https://share.google/cXN1DfEQzRdEuoTD3"
            >
              Kryzen Biotech Pvt Ltd.
            </a>
          </p>
          <p>
            CIN: U01100PN2019PTC186207 | GST: 27AAHCK7659R1ZF
            <br />
            Product of India, Developed for the world
          </p>
          <p className="mb-0 text-decoration-none">
            <span>
              <a href="/terms-condition" style={{ color: "#6c7a91" }}>
                Terms & Conditions
              </a>
            </span>{" "}
            -&nbsp;
            <span>
              <a href="/privacy-policy" style={{ color: "#6c7a91" }}>
                Privacy-Policy
              </a>
            </span>{" "}
            -&nbsp;
            <span>
              <a href="/refund-policy" style={{ color: "#6c7a91" }}>
                Refund Policy
              </a>
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default React.memo(FooterCopyright);
